import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-appid-1014-2",
  "use": "icon-appid-1014-2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-appid-1014-2\">\n  <path d=\"M2 4.75C2 4.33579 2.35817 4 2.8 4H17.2C17.6418 4 18 4.33579 18 4.75V15.25C18 15.6642 17.6418 16 17.2 16H2.8C2.35817 16 2 15.6642 2 15.25V4.75Z\" fill=\"#BDC9F2\" />\n  <path d=\"M5 8H15\" stroke=\"#3859B0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n  <path d=\"M11.25 12.3333H15\" stroke=\"#3859B0\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol